import { render, staticRenderFns } from "./LookupTranslator.vue?vue&type=template&id=715b0976&"
import script from "./LookupTranslator.vue?vue&type=script&lang=js&"
export * from "./LookupTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports